import { accountRequest } from './captureAccount';
export type TextAnimationArtifact = 'bvh' | 'motion' | 'video' | 'preview' | 'report';
export interface TextAnimationCapabilities {
  enabled: boolean; configured: boolean; development_preview: boolean;
  durations: number[]; max_prompt_characters: number; max_prompt_words: number;
  max_active: number; daily_limit: number | null; credits_per_animation_second: number; terms_version: string; motion_schema: string;
}
export interface TextAnimationJob {
  job_id: string; state: string; stage: string; progress: number; created_at: string;
  billing: {credits: number; charged: number; reserved: number}; error: string | null; artifacts_available: boolean;
  settings: {prompt: string; duration: number; seed: number; frames: number; fps: number};
}
const jobPath = (id: string) => 'text-animation/jobs/' + encodeURIComponent(id);
export const textAnimation = {
  async capabilities(signal?: AbortSignal): Promise<TextAnimationCapabilities> {
    return (await accountRequest('text-animation/capabilities', {signal})).json();
  },
  async list(signal?: AbortSignal): Promise<TextAnimationJob[]> {
    return (await (await accountRequest('text-animation/jobs', {signal})).json()).jobs;
  },
  async submit(prompt: string, duration: number, seed: number | null, terms: string, key: string): Promise<TextAnimationJob> {
    return (await accountRequest('text-animation/jobs', {method: 'POST',
      headers: {'Content-Type': 'application/json', 'Idempotency-Key': key},
      body: JSON.stringify({prompt, duration, seed, terms_version: terms})})).json();
  },
  async cancel(id: string): Promise<TextAnimationJob> {
    return (await accountRequest(jobPath(id) + '/cancel', {method: 'POST'})).json();
  },
  async artifact(id: string, kind: TextAnimationArtifact, signal?: AbortSignal): Promise<Blob> {
    return (await accountRequest(jobPath(id) + '/artifacts/' + kind, {signal})).blob();
  },
};
